import type { Zone } from 'store/types/types';

import { convert } from 'util/unitConversion';
import { UNIT_TYPES } from 'constants/unitTypes';

/**
 * Calculates the average target yield that can be passed to the getEstimatedYield function
 * @param zones The zones from a script scenario
 * @returns Target yield in 'kg/hectare'
 */
export const getAverageTargetYieldFromZones = (zones: Record<string, Zone>) => {
  const { targetYield, area } = Object.values(zones).reduce(
    (totals, zone) => {
      const convertedArea = convert({
        from: zone.meta.area,
        to: { u: UNIT_TYPES.ha }
      });

      totals.targetYield.q += zone.meta.highestYield.estimatedYield.q * convertedArea.q;
      totals.targetYield.u = zone.meta.highestYield.estimatedYield.u;
      totals.area.q += convertedArea.q;
      totals.area.u = UNIT_TYPES.ha;

      return totals;
    },
    { targetYield: { q: 0, u: '' }, area: { q: 0, u: '' } }
  );

  return { q: targetYield.q / area.q, u: targetYield.u };
};
